import {FormControl, FormHelperText, InputLabel, ListItemText} from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import React, {Dispatch, SetStateAction} from "react";
import Colors from "../../../../assets/Colors";
import { isApac } from "../../../../helpers/RegionHelper";

const userTypes = isApac ? ['driver', 'admin', 'superuser', ''] as const : ['driver', 'admin', 'owner', 'district_manager', ''] as const
export type UserType = typeof userTypes[number]

type UserTypeSelectProps = {
    userType: UserType;
    setUserType: Dispatch<SetStateAction<UserType>>;
    userTypeErrorMessage: string;
    contractDriver?: boolean;
}

function UserTypeSelect({userType, setUserType, userTypeErrorMessage, contractDriver}: UserTypeSelectProps) {
    return (
        <FormControl fullWidth={true}>
            <InputLabel id='user-type-select-label'>Select User Type</InputLabel>
            <Select
                labelId='user-type-select-label'
                onChange={(e) => setUserType(e.target.value as UserType)}
                value={userType}
                label="Select User Type"
            >
                {contractDriver ? (
                    <MenuItem key="driver" value="driver">
                    <ListItemText primary='driver' />
                    </MenuItem>
                ) : (
                    userTypes.map((type) =>
                    type ? (
                        <MenuItem key={type} value={type}>
                        <ListItemText primary={type} />
                        </MenuItem>
                    ) : null
                    )
                )}
            </Select>
            <FormHelperText sx={{ color: Colors.errorRed}}>{userTypeErrorMessage}</FormHelperText>
        </FormControl>
    )
}

export default UserTypeSelect